<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'twoOrderNew'}">两单管理</el-breadcrumb-item>
        <el-breadcrumb-item>辨识详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div style="width: 80%;margin: auto;padding-bottom:10px">
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">基础信息</span>
          </el-divider>
        </div>
        <div class="detailBox">
          <div>
            风险点：
            <span>{{ obj.riskName }}</span>
          </div>
          <div>
            所属部门：
            <span>{{ obj.depName }}</span>
          </div>
          <div>
            责任人：
            <span>{{ obj.responsibleEmpName }}</span>
          </div>
          <div>
            辨识人：
            <span>{{ obj.identifyUserName }}</span>
          </div>
          <div>
            审核人：
            <span>{{ obj.auditEmpName }}</span>
          </div>
          <div>
            审核状态：
            <span v-if="obj.status === 0" style="color: #F56C6C">未审核</span>
            <span v-else style="color: #67C23A">审核完成</span>
          </div>
          <div>
            审核时间：
            <span>{{ obj.auditTime }}</span>
          </div>
          <div>
            现场照片：
            <img v-if="obj.localePicture" :src="host + obj.localePicture" alt="" style="width: 150px;vertical-align: text-top">
          </div>
          <div>
            相关资料：
            <el-link v-if="obj.relevantFileUrl" type="primary" @click="downloadBtn(obj.relevantFileUrl, obj.relevantFileName)">{{ obj.relevantFileName }}</el-link>
          </div>
          <div>
            审核内容：
            <pre>{{ obj.auditOpinion }}</pre>
          </div>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">辨识内容</span>
          </el-divider>
        </div>
        <el-table :data="obj.measure" border max-height="600" style="width: 100%"
          :header-cell-style="{ background: 'white', fontWeight: 600, textAlign: 'center', padding: '8px 0' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column
            type="index"
            :index="(index) => {return index + 1}"
            width="80"
            label="序号"
          ></el-table-column>
          <el-table-column prop="project" label="检查项目/作业步骤"></el-table-column>
          <el-table-column prop="name" label="检查标准/风险源或潜在事件"></el-table-column>
          <el-table-column prop="riskFactor" label="风险因素"></el-table-column>
          <el-table-column prop="riskDescription" label="不符合标准状况/可能发生事故描述"></el-table-column>
          <el-table-column prop="type" label="易发事故类型"></el-table-column>
          <el-table-column prop="consequence" label="危害/后果"></el-table-column>
          <el-table-column label="是否通过">
            <template slot-scope="{ row }">
              <span v-if="row.riskControlId === 0" style="color: #F56C6C">未管控</span>
              <span v-else style="color: #67C23A">已管控</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="{row}">
              <span style="cursor: pointer;color: red" @click="deteleDetail(row.id)">删除</span>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { downLoadDocument } from '@/api/downLoad'
export default {
  name: 'riskIdentificationDetail',
  data() {
    return {
      obj: {},
    }
  },
  methods: {
    downloadBtn(val1, val2) {
      downLoadDocument(val1, val2);
    }
  },
  created() {
    this.obj = this.$route.params.data
  }
}
</script>

<style scoped>
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
}
</style>